import { render, staticRenderFns } from "./default2.vue?vue&type=template&id=07a569be&scoped=true"
import script from "./default2.vue?vue&type=script&lang=js"
export * from "./default2.vue?vue&type=script&lang=js"
import style0 from "./default2.vue?vue&type=style&index=0&id=07a569be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a569be",
  null
  
)

export default component.exports